import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MainService } from '../../../../services';
@Component({
  selector: 'app-dialog-notifica',
  templateUrl: './dialog-notifica.component.html',
  styleUrls: ['./dialog-notifica.component.css']
})
export class DialogNotificaComponent {

  messaggio: string;
  titolo: string;

  constructor(public dialogRef: MatDialogRef<DialogNotificaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {titolo: string, messaggio: string}) 
  {
    this.messaggio = data.messaggio;
    this.titolo = data.titolo;
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-notifica/dialog-notifica.component.ts